document.addEventListener('DOMContentLoaded', init)
function init() {
  if(typeof Swiper !== 'undefined') {
    const swiper = new Swiper('.testimonail-swiper', {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    })
  }
}